import { render, staticRenderFns } from "./LenderForm.vue?vue&type=template&id=10e05c4b&scoped=true&"
import script from "./LenderForm.vue?vue&type=script&lang=js&"
export * from "./LenderForm.vue?vue&type=script&lang=js&"
import style0 from "./LenderForm.vue?vue&type=style&index=0&id=10e05c4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e05c4b",
  null
  
)

export default component.exports